import { defineComponent, h } from 'vue'

/** Cache wrappers so keep-alive can match by route.name without renaming page SFCs. */
const wrapperCache = Object.create(null)

export function wrapTabComponent(Component, routeName) {
  if (!Component || !routeName) return Component

  if (!wrapperCache[routeName]) {
    wrapperCache[routeName] = defineComponent({
      name: routeName,
      setup() {
        return () => {
          const raw = wrapperCache[routeName].__raw
          return raw ? h(raw) : null
        }
      },
    })
  }

  wrapperCache[routeName].__raw = Component
  return wrapperCache[routeName]
}

export function dropTabComponent(routeName) {
  if (routeName && wrapperCache[routeName]) {
    delete wrapperCache[routeName]
  }
}
